import { render } from "./HomeSection.vue?vue&type=template&id=c5ab4480&scoped=true&ts=true"
import script from "./HomeSection.vue?vue&type=script&lang=ts"
export * from "./HomeSection.vue?vue&type=script&lang=ts"

import "./HomeSection.vue?vue&type=style&index=0&id=c5ab4480&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ab4480"]])

export default __exports__